import CalendarItemNotificationPayload from 'owa-service/lib/contract/CalendarItemNotificationPayload';
import deleteCalendarEventsByInstanceKeysAndNotify from '../../../store/apis/deleteCalendarEventsByInstanceKeysAndNotify';

/**
 * Handles a row deleted notification. When we receive a RowDeleted notification, we don't know if
 * it is for a single or recurring item, because the only piece of data that RowDeleted notifications
 * carry is the InstanceKey. Therefore, we won't have special processing for single vs recurring like
 * in the other cases.
 */
export default function handleRowDeletedNotification(
    notification: CalendarItemNotificationPayload
) {
    const instanceKey = notification.Item.InstanceKey;

    // We treat this just as removing a series
    deleteCalendarEventsByInstanceKeysAndNotify([instanceKey]);
}
